import { z } from 'zod';
import { BooleanOptional, StringOptional } from './schemaTypes';

export const AccountSchema = z.object({
	engineURL: StringOptional.describe(
		'Адрес страницы с модулем Engine (используется для FastSearch поиска, перехода на страницу заказа)'
	),
	showUserPhoneInput: BooleanOptional.describe('Отображать поле ввода номера телефона на странице Настройки'),
	openCheckinPageOnProfileControlsClick: BooleanOptional.describe(
		'При true перенаправляет на страницу, указанную в настройке Engine.checkInURL, вместо отображения модального окна (WEBSKY-3508)'
	),
	showCommunications: BooleanOptional.describe('Указывает нужно ли раздел коммуникации в личном кабинете'),
	showSubscribeCheckbox: BooleanOptional.describe(
		'Указывает нужно ли отображать чекбокс с подпиской на рассылку в Личном кабинете'
	),
	initialStayLoggedIn: BooleanOptional
});
